import { restRequest } from "vrcore-dashboard/dist/utilities.js";

export const VRCORE_GET_TEMPLATES = restRequest("VRCORE_GET_TEMPLATES");
export const VRCORE_ADD_TEMPLATE = restRequest("VRCORE_ADD_TEMPLATE");
export const GET_REPORT_TITLES = restRequest("VRCORE_GET_REPORT_TITLES");
export const VRCORE_EDIT_TEMPLATE = restRequest("VRCORE_EDIT_TEMPLATE");

export const VRCORE_REMOVE_TEMPLATE = restRequest("VRCORE_REMOVE_TEMPLATE");
